"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 0;\n  font-family: ", ";\n\n  .label {\n    margin: 0 0 6px;\n    font-size: 14px;\n    color: ", ";\n  }\n\n  &.disabled .label {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 0;\n  font-family: ", ";\n\n  .label {\n    margin: 0 0 6px;\n    font-size: 14px;\n    color: ", ";\n  }\n\n  &.disabled .label {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map